import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-admin';
import { useQueryClient } from 'react-query';

import useCustomRpc from '../../hooks/useCustomRpc';
import { payoutClaimsQueryKey } from '../../hooks/usePayoutClaims';
import { finalPayoutClaimStatuses, usePayoutClaim } from './PayoutClaimStatus';

// Fetches the claim's latest status from PI. It never sends a payout.
const RefreshPayoutClaimButton = ({ accountId }) => {
  const claim = usePayoutClaim(accountId);
  const queryClient = useQueryClient();

  const { mutate: refreshPayoutClaim, isLoading } = useCustomRpc({
    httpMethod: 'POST',
    path: `account/${accountId}/transactions/${claim?.transactionId}/payout-claim/refresh`,
    successMessage: 'Payout status refreshed',
    errorMessage: 'Failed to refresh payout status',
    onSuccess: () => queryClient.invalidateQueries(payoutClaimsQueryKey(accountId)),
  });

  if (!claim || finalPayoutClaimStatuses.includes(claim.status)) return null;

  return (
    <Button
      label="Refresh payout status"
      disabled={isLoading}
      onClick={() => refreshPayoutClaim()}
    />
  );
};

RefreshPayoutClaimButton.propTypes = {
  accountId: PropTypes.string,
};

RefreshPayoutClaimButton.defaultProps = {
  accountId: undefined,
};

export default RefreshPayoutClaimButton;
